import { useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';
import { login } from '../../api/auth.ts';
import { ApiError } from '../../api/client.ts';
import { Button, TextField } from '../../components/ui.tsx';
import { DARK_TOAST } from '../../components/Layout.tsx';

const MOCKS = import.meta.env.VITE_ENABLE_MOCKS === 'true';

export function LoginPage() {
  const qc = useQueryClient();
  const [email, setEmail] = useState(MOCKS ? 'alex@glendale.test' : '');
  const [password, setPassword] = useState(MOCKS ? 'demo' : '');

  const mut = useMutation({
    mutationFn: () => login({ email, password }),
    onSuccess: async () => {
      await qc.invalidateQueries();
      window.location.href = '/';
    },
  });

  const errorMsg =
    mut.error instanceof ApiError ? mut.error.message : mut.error ? 'Something went wrong' : undefined;

  return (
    <div className="auth-wrap">
      <form
        className="auth-card"
        onSubmit={(e) => {
          e.preventDefault();
          mut.mutate();
        }}
      >
        <div className="brand">
          <span>SeenCast</span>
        </div>
        <div className="brand-sub">AI-powered digital signage by SeenLabs</div>
        <TextField
          label="Email"
          type="email"
          autoComplete="username"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <TextField
          label="Password"
          type="password"
          autoComplete="current-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          error={errorMsg}
          required
        />
        <Button variant="primary" type="submit" disabled={mut.isPending} style={{ width: '100%' }}>
          {mut.isPending ? 'Signing in…' : 'Sign in'}
        </Button>
        {MOCKS && (
          <p className="hint mt-4">
            Demo backend (MSW): sign in as <code>alex@glendale.test</code> with any password.
          </p>
        )}
      </form>
      <Toaster position="bottom-right" toastOptions={DARK_TOAST} />
    </div>
  );
}
